import {Pipe, PipeTransform} from '@angular/core';
import appUtil from '../util/app.util';

@Pipe({
  name: 'amPm',
  standalone: true,
})
export class AmPmPipe implements PipeTransform {
  transform(time: string): string {
    if (appUtil.isEmpty(time)) {
      return time;
    }
    let hour = parseInt(time.substring(0, 2), 10);
    const minute = time.substring(3, 5);
    const period = hour < 12 ? 'AM' : 'PM';

    if (hour === 0) {
      hour = 12;
    } else if (hour > 12) {
      hour = hour - 12;
    }

    return hour + ':' + minute + ' ' + period;
  }
}
